import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CartReconciliationService } from './core/services/cart-reconciliation.service';
import { PermissionsService } from './core/services/permissions.service';
import { PromotionCalculationService } from './core/services/promotion-calculation.service';
import { CartUpdateNotice } from './shared/components/cart-update-notice/cart-update-notice';
import { OrderCancelledNotice } from './shared/components/order-cancelled-notice/order-cancelled-notice';
import { PermissionGate } from './shared/components/permission-gate/permission-gate';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PermissionGate, OrderCancelledNotice, CartUpdateNotice],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly permissions = inject(PermissionsService);
  // Injected here (rather than only where it's read) so it starts watching the cart from app
  // startup - every add/increase/decrease anywhere recalculates promotions, not just on checkout.
  private readonly promotionCalculation = inject(PromotionCalculationService);
  // Same reasoning - reconciles a restored cart against the live catalog on every page load,
  // regardless of which route (menu/cart/checkout) the app happened to boot on.
  private readonly cartReconciliation = inject(CartReconciliationService);

  readonly allGranted = this.permissions.allGranted;
}
